export default "__VITE_ASSET__CwpsyLb3__"